import React from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Image from 'next/image'

import { historyUtils } from '@wartek-id/toolbox-helper'

import { Header } from 'components/Header'
import { GeneralNoticeState } from 'components/NoticeState'

export const ForYouPage = ({}) => {
  const router = useRouter()

  return (
    <div className="absolute flex inset-0 items-center px-10 text-center">
      <GeneralNoticeState
        icon={
          <Image
            alt=""
            width={120}
            height={120}
            className="pointer-events-none"
            src="images/errors/img-maintenance.svg"
          />
        }
        title="Akses fitur ini di aplikasi, ya..."
        description="Maaf, saat ini Untuk Anda baru bisa diakses lewat aplikasi PMM."
        showButton
        buttonLabel="Kembali ke Beranda"
        onButtonClick={() => {
          historyUtils.backToApp(() => router.push('/home'))
        }}
      />
    </div>
  )
}

const PageHeader = () => (
  <>
    <Head>
      <title>Untuk Anda</title>
    </Head>
    <Header hasBackButton title="" titlePosition="left" />
  </>
)
ForYouPage.layoutOpts = {
  hasHeader: true,
  header: PageHeader,
}

export default ForYouPage
